import React, { Component } from "react";
import _ from 'lodash';
import {Table,Pagination,Row, Col, Button} from 'react-bootstrap';
import AgentScreen from './AgentScreen'
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

export default class AgentInbox extends Component {
  constructor(props){
    super(props)
    this.state = {
      Headers:[],
      activePage:1,
      orderBy:'asc',
      data:props.data,
      monthCycle:[],
      startDate:null
    }
   
  }
  componentDidMount(){   
    var d = new Date();
    d.setDate(d.getDate() - 1);
    this.setState({startDate:d})
    let previousdate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    let obj = {callDate:previousdate, userId:this.props.loginUserName} 
    this.props.action.TokenValidation()      
    this.props.action.agentworkList(obj)   
  }
  componentWillReceiveProps(nextProps){ 
    const {monthCycle} = this.state;
    //let previousdate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    let obj = {}
   let month= ""
    if(!_.isEmpty(monthCycle)){
      month = monthCycle.label
    } 
    if(!_.isNull(this.state.startDate)){
      let date = moment(this.state.startDate).format('YYYY-MM-DD')
      obj = {callDate:date, userId:this.props.loginUserName} 
    } else {
      obj = {userId:this.props.loginUserName, monthCycle:month} 
    }
  if(nextProps.submitted === true){
    nextProps.action.agentworkList(obj)  
    nextProps.action.ResetSubmitted()
  }
  if(!_.isEqual(nextProps.action.showModalLogin, this.props.action.showModalLogin) && nextProps.action.showModalLogin === false){     
    nextProps.action.agentworkList(obj) 
  }
  if(!_.isEqual(this.props.data,nextProps.data)){
    this.setState({data:nextProps.data})
  }  
}

renderInboxValues = (Rows, startOffset, startCount, Per_Page) => { 
  //const{activePage} = this.state;   
  let returnObj;  
  if(!_.isEmpty(Rows)){
    returnObj =  _.map(Rows, (obj, i) =>{
      let title = '';
      title = title.concat(obj.regionName, ' - ', obj.centerName, ' - ', obj.clientName, ' - ',obj.processName, ' - ',obj.agentName, ' - ',obj.callDate)
      if(i >= startOffset & startCount < Per_Page){
        startCount++;
            return(<tr onDoubleClick={()=>this.handleDoubleClick(i, obj.id)}>
            {this.state['showDouble'+i] ? <AgentScreen closeModal={()=>this.onClose(i)} object={obj}
            title={title}
            CompletedAuditsView={this.props.CompletedAuditsView}
            loginUserName={this.props.loginUserName} ScoreCalculation={this.props.ScoreCalculation}
        action={this.props.action}  
        /> 
          : null}
            <td>{obj.id}</td>
            <td>{obj.updated_date}</td>            
            <td>{obj.callDate}</td>
            <td>{obj.msisdn}</td>
            <td>{obj.auditorName}</td>             
            <td>{obj.regionName}</td>
            <td>{obj.centerName}</td>
            <td>{obj.clientName}</td>
            <td>{obj.processName}</td>
            <td>{obj.overallAttributeScore}</td>            
          </tr>)
      }
    })
  } 
  else {
    returnObj=(<tr><td colSpan="11">No Record Found</td></tr>)
  }
  return returnObj;
}
handleDoubleClick = (i, id) => { 
  this.setState({['showDouble'+i]:true})
  this.props.action.auditorScoreCalculation(id)
}
onClose = (i) => {
  this.setState({['showDouble'+i]:false})
}
handleSelectPagination = (eventKey) => {
  this.setState({
    activePage: eventKey,
  });
}
handleSelectPaginationPrev = () => {
  const {activePage} = this.state;
  this.setState({
    activePage: activePage-1,
  });
}
handleSelectPaginationNext = () => {
  const {activePage} = this.state;
  this.setState({
    activePage: activePage+1,
  });
}
handleSort = (column) => {
  const {orderBy, data} = this.state
  var data1 = _.orderBy(data, [column], orderBy);
  this.setState({data:data1})
  if(orderBy === "asc"){
   this.setState({orderBy:"desc"})
  } else {
   this.setState({orderBy:"asc"})
  }
}

searchData = () =>{
  const{startDate, monthCycle} = this.state;
  let date = moment(startDate).format('YYYY-MM-DD')
 let month= ""
  if(!_.isEmpty(monthCycle)){
    month = monthCycle.label
  } 
  let obj = {callDate:startDate ? date : "", userId:this.props.loginUserName, monthCycle:month} 
  this.props.action.agentworkList(obj)  
}
handleSelectMonth = (e) =>{
  this.setState({monthCycle:e, startDate:null})
}
handleChangeStart = (date) =>{
  this.setState({startDate:date, monthCycle:[]})
}

resetData = () =>{
  this.setState({startDate: null,  monthCycle:{'label':'Current Month'}})
  let previousdate = moment().subtract(1, 'days').format('YYYY-MM-DD')
  let obj = {callDate:previousdate, userId:this.props.loginUserName, monthCycle:'Current Month'} 
  this.props.action.agentworkList(obj)
}

render(){ 
  const{activePage,data, startDate} = this.state;
  const Per_Page=50;  
  let totalPages = 1
  if(!_.isEmpty(data)){
    totalPages = Math.ceil(data.length/Per_Page)
  }
  let items = []; 
  const startOffset = (this.state.activePage-1) * Per_Page;
  let startCount = 0;
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
        {number}
      </Pagination.Item>				
    );
  }
 return(
   <div>
     <Row  className='rowvertical'>  
      <Col  md={1} className='paddingLeft'><b><center>Call Date</center></b></Col>
      <Col md={2}><DatePicker
            selected={startDate}
            className='myDatePicker'
            selectsStart
            showMonthDropdown
            onChange={this.handleChangeStart}
            /></Col>     
       <Col md={2}><Picky keepOpen={false}
            value={this.state.monthCycle}
            options={[{'label':'Previous Month'},{'label':'Current Month'}]}
            onChange={this.handleSelectMonth}
            open={false}
            valueKey="label"
            labelKey="label"
            placeholder='Choose Month'
            multiple={false}
            includeSelectAll={false}
            includeFilter={true}
            clearFilterOnClose={true}
            dropdownHeight={600}
          />      
      </Col> 
      <Col><Button onClick={this.searchData}>Search</Button></Col> 
      <Col><Button onClick={this.resetData}>Reset</Button></Col>
      <Col md={4}></Col>   
    </Row>
    <Table responsive>
     <thead>
       <th>TRANSACTION NO <i class="fas fa-sort" onClick={()=>this.handleSort('id')}/></th>
        <th>AUDITED DATE <i class="fas fa-sort" onClick={()=>this.handleSort('updated_date')}/></th>           
        <th>CALL DATE</th>
        <th>MOBILE NO</th>
        <th>AUDITOR NAME</th>  
        <th>REGION</th>
        <th>CENTER</th>
        <th>CLIENT</th>        
        <th>PROCESS</th>
        <th>OVERALL SCORE WITH FATAL</th>
      </thead>
      <tbody>
        { this.renderInboxValues(data, startOffset, startCount, Per_Page) }      
      </tbody>
    </Table>
    {!_.isEmpty(items) ?
     <Pagination> 
     <Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
     <Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
      {items[activePage-1]}
      {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
      {items[activePage+1]}
     <Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
     <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
   </Pagination> : null}
   </div>
   )
}
}